import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'simple-react-modal';
import moment from 'moment';

import { CALENDAR_DISPLAY } from '../../constants/modals';

import { dismissModal } from './services';


const CalendarPromoModal = (props) => {
  const { showCalendarModal, closeCalendarModal, user, realCountryCode } = props;
  const countryCodeMapper = {
    DE: 'Germany',
    FR: 'France',
    NL: 'the Netherlands',
    GB: 'United Kingdom',
  };
  const supportedCountries = ['DE', 'NL', 'GB', 'FR'];
  const handleDismissForever = () => {
    if (user.authenticated) {
      dismissModal({
        visible: false,
        count: 1,
        modalType: CALENDAR_DISPLAY,
      });
    } else {
      const tenYears = moment().
        add(10, 'years').
        toDate();
      setCookie(tenYears);
    }
    closeCalendarModal();
  };

  const handleClose = () => {
    if (user.authenticated) {
      dismissModal({
        visible: true,
        count: 1,
        modalType: CALENDAR_DISPLAY,
      });
    } else {
      const nextWeek = moment().
        add(7, 'days').
        toDate();
      setCookie(nextWeek);
    }
    closeCalendarModal();
  };

  const setCookie = (expiry) => {
    document.cookie = `CALENDAR_DISPLAY=hidden; expires=${expiry}`;
  };

  const showShippingMessage = realCountryCode && supportedCountries.includes(realCountryCode);

  return (
    <Modal
      closeOnOuterClick={true}
      containerClassName="calendar-modal"
      show={showCalendarModal}
      onClose={handleClose}
    >
      <div className={'calendar-modal-content'}>
        <div className="calendar-modal-text-holder">
          <p>Now available!</p>
          <h1>2023</h1>
          <h4>Naked News Calendar!</h4>
          <div className="calendar-modal-first-paragraph">
            {' '}
            <ul>
              <li>The entire cast of Naked News in 12 months of stunning images.<br />
                Each month is a celebration of their incredible natural beauty.</li>
              <li><b>ADDED BONUS</b></li>
              <li>Also get 1 free month of your favorite anchors Fan Zone.
                This is your chance to connect with them on a more personal and intimate level.
              </li>
              <li><b>DON&apos;T MISS OUT</b></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="calendar-modal-footer">
        <a
          className="btn btn-red"
          href="https://shop.nakednews.com/index.php/product/naked-news-2023-calendar/"
          rel="noreferrer"
          target="_blank" onClick={closeCalendarModal}
        >
          ORDER YOUR CALENDAR TODAY!
        </a>
        <div className="calendar-modal-dismiss" onClick={handleDismissForever}>
          I don&apos;t want to see this message again
        </div>
      </div>
      <span className="calendar-modal-close-btn" onClick={handleClose}>X</span>
    </Modal>
  );
};

export default observer(CalendarPromoModal);
